import PropTypes from 'prop-types';
import React from 'react';
import { FlexRow, Semaphore, Tooltip } from 'styleguide';

import { CONTENT_PUBLISHED_STATES } from 'commons/models/notebook';
import { getPublishedState } from 'dashboard/pages/Content/utils';

const tooltipText = {
  [CONTENT_PUBLISHED_STATES.ARCHIVED]: 'This Content is archived.',
  [CONTENT_PUBLISHED_STATES.PUBLISHED]: 'All changes to this Content are published.',
  [CONTENT_PUBLISHED_STATES.UNSYNCED]: 'This Content has updates that have not been published.',
  [CONTENT_PUBLISHED_STATES.DRAFT]: 'This Content has never been published.',
};

const text = {
  [CONTENT_PUBLISHED_STATES.ARCHIVED]: 'Archived',
  [CONTENT_PUBLISHED_STATES.PUBLISHED]: 'Live',
  [CONTENT_PUBLISHED_STATES.UNSYNCED]: 'Pending changes',
  [CONTENT_PUBLISHED_STATES.DRAFT]: 'Draft',
};

const colors = {
  [CONTENT_PUBLISHED_STATES.ARCHIVED]: 'blue',
  [CONTENT_PUBLISHED_STATES.PUBLISHED]: 'active',
  [CONTENT_PUBLISHED_STATES.UNSYNCED]: 'warning',
  [CONTENT_PUBLISHED_STATES.DRAFT]: 'neutral',
};

export const ContentPublishedState = ({ content, semaphoreOnly, ...props }) => {
  const status = getPublishedState(content);
  const semaphore = (
    <Semaphore
      {...props}
      color={colors[status]}
      size="xs"
      css={{ alignSelf: 'center' }}
      shade={status === CONTENT_PUBLISHED_STATES.DRAFT ? 3 : 0}
    />
  );
  if (semaphoreOnly) {
    return semaphore;
  }
  return (
    <FlexRow size="sm" data-cy={`publish-state-${status}`}>
      {semaphore}
      <Tooltip position="top" content={tooltipText[status]}>
        <span style={{ width: '50px' }}>{text[status]}</span>
      </Tooltip>
    </FlexRow>
  );
};

ContentPublishedState.propTypes = {
  content: PropTypes.object.isRequired,
  semaphoreOnly: PropTypes.bool,
};

export default ContentPublishedState;
